// @ts-expect-error not typed
import { keepIndexBetweenArrayBounds, removeSpanAndResetState } from './utils';
import { autocompleteQuickInsertIsActiveAtom, filteredAutocompleteCommandsAtom, updateActiveAutocompleteCommand, activeAutocompleteCommandAtom, updateAutocompleteEscaped, autocompleteCommandIsActiveAtom, autocompleteResultPopoverIsActiveAtom
// @ts-expect-error not typed
} from '../data/autocompleteAtoms';
import { getAtomValue } from '../data/atomUtils';
let wasCommandSelectedOnEnter = false;
export function resetCommandSelectedOnEnter() {
  wasCommandSelectedOnEnter = true;
}
export const getCommandWasSelectedOnEnter = () => wasCommandSelectedOnEnter;
function preventDefaultAndStopPropagation(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
}
export function handleNavigationKeyDown(e, editor) {
  const autocompleteQuickInsertIsActive = getAtomValue(autocompleteQuickInsertIsActiveAtom);
  const autocompleteCommandIsActive = getAtomValue(autocompleteCommandIsActiveAtom);
  const autocompleteResultMenuIsOpen = getAtomValue(autocompleteResultPopoverIsActiveAtom);
  if (!autocompleteQuickInsertIsActive && !autocompleteCommandIsActive && !autocompleteResultMenuIsOpen) {
    return;
  }
  if (autocompleteResultMenuIsOpen) {
    if (e.key === 'Escape') {
      removeSpanAndResetState(editor);
    }
    return;
  }
  const currentFilteredCommands = getAtomValue(filteredAutocompleteCommandsAtom);
  const currentActiveAutocompleteCommandIndex = getAtomValue(activeAutocompleteCommandAtom);
  switch (e.key) {
    case 'Tab':
    case 'ArrowDown':
      {
        const nextCommandIndex = keepIndexBetweenArrayBounds(currentActiveAutocompleteCommandIndex + 1, currentFilteredCommands.length);
        updateActiveAutocompleteCommand(nextCommandIndex);
        preventDefaultAndStopPropagation(e);
        break;
      }
    case 'ArrowUp':
      {
        const nextCommandIndex = keepIndexBetweenArrayBounds(currentActiveAutocompleteCommandIndex - 1, currentFilteredCommands.length);
        updateActiveAutocompleteCommand(nextCommandIndex);
        preventDefaultAndStopPropagation(e);
        break;
      }
    case 'Enter':
      {
        if (currentActiveAutocompleteCommandIndex == null) {
          preventDefaultAndStopPropagation(e);
          return;
        }
        const currentCommand = currentFilteredCommands[currentActiveAutocompleteCommandIndex];
        if (!currentCommand) {
          preventDefaultAndStopPropagation(e);
          return;
        }
        wasCommandSelectedOnEnter = true;
        preventDefaultAndStopPropagation(e);
        currentCommand.onSelect();
        break;
      }
    case 'Escape':
      {
        // Close the autocomplete menu and set its state to "escaped"
        // so that further updates don't open the menu again
        if (autocompleteQuickInsertIsActive) {
          updateAutocompleteEscaped(true);
        }
        removeSpanAndResetState(editor);
        preventDefaultAndStopPropagation(e);
        break;
      }
    default:
      return;
  }
}